import { useEffect, useState } from 'react';
import { loadAllPropFirmData } from '../data/propFirmData';
import HeroCarouselCard from './HeroCarouselCard';
import { getBestDiscount } from '../utils/getBestDiscount';

import type { Challenge, Discount } from '../utils/getBestDiscount';

interface FirmFeatures {
  maxFunding: string;
  profitSplit: number;
}

interface Firm {
  id: string;
  name: string;
  features: FirmFeatures;
  discounts?: Discount[];
  pricing?: Challenge[];
}

export function HeroCarousel() {
  const [firmsWithDiscounts, setFirmsWithDiscounts] = useState<Firm[]>([]);

  useEffect(() => {
    loadAllPropFirmData().then((firmData: Record<string, Firm>) => {
      const filtered = Object.values(firmData).filter((firm: Firm) => {
        const challenge = firm.pricing?.find((p: Challenge) => p.phases === 2 && p.accountSize === 100000);
        const discount = getBestDiscount(firm.discounts || [], challenge);
        return !!discount?.code;
      });
      setFirmsWithDiscounts(filtered);
    });
  }, []);

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % firmsWithDiscounts.length);
    }, 7000);
    return () => clearInterval(interval);
  }, [firmsWithDiscounts.length]);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev - 1 + firmsWithDiscounts.length) % firmsWithDiscounts.length);
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % firmsWithDiscounts.length);
  };

  const currentFirm = firmsWithDiscounts[currentIndex];

  return (
    <div className="flex justify-center items-center w-full">
      <HeroCarouselCard firm={currentFirm} onPrev={handlePrev} onNext={handleNext} />
    </div>
  );
}

export default HeroCarousel;
